export function EmptyTabCard({ text }: { text: string }) {
  return (
    <div className="card">
      <div className="card-body" style={{ padding: 40, textAlign: 'center' }}>
        <div className="muted" style={{ fontSize: 15 }}>
          {text}
        </div>
      </div>
    </div>
  );
}
